import {
  Box,
  Card,
  CardBody,
  Flex,
  Image,
  Stack,
  Text,
  useMediaQuery,
} from "@chakra-ui/react";
import React from "react";
import { getBackgroundColor, getPixelCount } from "../../utils";
import { useNavigate, useLocation } from "react-router-dom";
import { LockIcon } from "@chakra-ui/icons";

const GrowthPlanCard = ({
  leftTitle = "",
  rightTitle = "",
  leftAmount = "-",
  rightAmount = "-",
  rightPercentage = "-",
  cardHeight = "108px",
  cardWidth = "100%",
  color = "black",
  image = null,
  type,
  isLocked = false,
}) => {
  const [isMobile] = useMediaQuery("(max-width: 1280px)");
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = () => {
    if (type) {
      navigate(`/lucro-metrics/${type}/${"growth"}`, {
        state: { from: location.pathname },
      });
    }
  };
  return (
    <Card
      fontFamily={"lato"}
      width={cardWidth}
      height={cardHeight}
      borderRadius="10px"
      overflow="hidden"
      position="relative"
      onClick={!isLocked ? handleClick : undefined}
      _hover={type && !isLocked && { boxShadow: "xl", cursor: "pointer" }}
    >
      <CardBody
        p={"16px 24px"}
        display="flex"
        alignItems="center"
        position="relative"
      >
        <Box flex="1" height="64px" textAlign="left">
          <Flex align="center" justify="flex-start" gap={4}>
            <Box width="100%" textAlign="left">
              <Box
                p="0px 0px 2px 0px"
                fontSize="16px"
                color="#202224"
                height="25px"
                whiteSpace="nowrap"
              >
                {leftTitle}
              </Box>
              <Box fontWeight={800} maxHeight="30px">
                <Text
                  whiteSpace="nowrap"
                  fontSize={getPixelCount(
                    "clamp(22px, calc(1.6cqw - 0.09vw), 30px)",
                    leftAmount,
                    8,
                    0.2
                  )}
                >
                  {leftAmount}
                </Text>
              </Box>
            </Box>
          </Flex>
        </Box>

        <Box
          position="absolute"
          top="50%"
          left="50%"
          transform="translate(-50%, -50%)"
          width="2px"
          height="64px"
          backgroundColor="gray.300"
        />

        <Box flex="1" height="64px" pl="20px" textAlign="left">
          <Flex align="center" justify="flex-start" gap={4}>
            <Box width="100%">
              <Box
                p="0px 0px 2px 0px"
                fontSize="16px"
                height="25px"
                color="#202224"
              >
                <Text whiteSpace="nowrap">{rightTitle}</Text>
              </Box>
              <Box height="64px">
                <Stack p={0}>
                  <Box
                    fontSize={getPixelCount(
                      "clamp(14px, calc(1.5cqw - 0.11vw), 18px)",
                      rightAmount,
                      8,
                      0.1
                    )}
                    fontWeight={600}
                    lineHeight={1}
                    whiteSpace="nowrap"
                  >
                    {rightAmount}
                    <Text
                      fontSize="clamp(12px, calc(1.5cqw - 0.11vw), 14px)"
                      fontWeight={200}
                      p="6px 0px"
                      color={color}
                      whiteSpace="nowrap"
                    >
                      {rightPercentage}
                    </Text>
                  </Box>
                </Stack>
              </Box>
            </Box>
          </Flex>
        </Box>

        <Box
          position="absolute"
          top="50%"
          right="20px"
          transform="translateY(-50%)"
          backgroundColor={!isMobile && getBackgroundColor(image)}
          borderRadius="15px"
          width="64px"
          height="64px"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          {!isMobile && (
            <Image src={image} alt="Image" boxSize="40px" objectFit="contain" />
          )}
        </Box>

        {isLocked && (
          <Box
            position="absolute"
            top={0}
            left={0}
            w="100%"
            h="100%"
            bg="rgba(255, 255, 255, 0.7)"
            backdropFilter="blur(5px)"
            zIndex={10}
            display="flex"
            flexDir={"column"}
            alignItems="center"
            justifyContent="center"
          >
            <LockIcon></LockIcon>
            <Text
              fontWeight={700}
              fontSize="lg"
              color="gray.700"
              p={2}
              textAlign={"center"}
            >
              Upgrade to Unlock {leftTitle}
            </Text>
          </Box>
        )}
      </CardBody>
    </Card>
  );
};

export default GrowthPlanCard;
